<template>
  <div class="navbar">
    <div class="container clearfix">
      <div class="navbar-logo">
        <router-link to="/" class="navbar-brand">
          <img src="/static/img/logo.png">
        </router-link>
      </div>
      <div class="navbar-phone stxihei" v-show="$store.state.city.remarks">{{$store.state.city.remarks}}</div>
      <div class="navbar-city">
        <span class="current-city">
          {{$store.state.city.name}}
          <i>[切换城市]</i>
        </span>
        <ul class="city-list">
          <li class="city-item" v-for="(item, index) in cityList" :class="{'active': item.active}" :key="index" @click="onClick(index)">{{item.cityName}}</li>
        </ul>
      </div>
      <ul class="navbar-navs">
        <li class="navbar-item" v-for="(item, index) in menuArr" :class="item.cls" :key="index">
          <router-link :to="item.to" exact v-if="!item.children || item.children.length === 0">
            {{item.text}}
          </router-link>
          <a href="javascript:;" v-else>
            {{item.text}}
            <span class="angle"></span>
            <ul class="navbar-subbar clearfix">
              <li class="navbar-subbar-item" v-for="(subNav, index) in item.children" :key="index">
                <router-link :to="subNav.to" exact :target="subNav.target">{{subNav.text}}</router-link>
              </li>
            </ul>
          </a>
        </li>
        <li class="navbar-item">
          <a :href="'http://pms.91weijia.com/public-service/query_service.html?cityCode=' + cityCode + '&channel=0'" target="_blank">查询服务</a>
        </li>
      </ul>
      <div class="navbar-userInfo">
        <div v-if="!$store.state.token" class="user-info noLogin">
          <a href="javascript:;" class="active" @click="toLogin">登录</a>
          <router-link to="/register">注册</router-link>
        </div>
        <div v-if="$store.state.token" class="user-info isLogin">
          <router-link type="span" class="active" to="/u/order">{{userPhone}}</router-link>
          <a class="logout" href="javascript:;" @click="toLogout">【安全退出】</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import store from 'store'

export default {
  name: 'Navbar',
  data () {
    return {
      cityList: [],
      isShow: false,
      isBorrowActive: false,
      isConsultantActive: false,
      menuArr: [{
        text: '首页',
        to: '/',
        reg: /^\/$/
      }, {
        text: '产品介绍',
        to: '/borrow',
        reg: /^\/borrow/
      }, {
        text: '业务咨询',
        to: '/consultant/counserlor',
        reg: /^\/consultant/
      }, {
        text: '关于我们',
        // to: '/about/company',
        reg: /^\/about/,
        children: [{
          text: '公司介绍',
          to: '/about/company',
          reg: /^\/about\/company/,
          target: '_blank'
        }, {
          text: '伟嘉视角',
          to: '/about/perspective',
          reg: /^\/about\/perspective/,
          target: '_blank'
        }, {
          text: '企业文化',
          to: '/about/culture',
          reg: /^\/about\/culture/,
          target: '_blank'
        }]
      }],
      cityCode: ''
    }
  },
  watch: {
    '$store.state.city' (city) {
      this._getCounselorCountByCity()
      this.cityCode = city.code || ''
    },
    '$route' () {
      this.setNavActive()
    }
  },
  created () {
    let city = store.get('city') || {}
    this.cityCode = city.code || ''
    this.setNavActive()
    this._fetchData()
    this._getCounselorCountByCity()
    this.isBorrowActive = (this.$route.query.sceneid != null)
    this.isConsultantActive = (this.$route.params.select != null)
  },
  computed: {
    userPhone () {
      return ''.replace.call(this.$store.state.token.phone, /^(\d{3})(\d{6})(\d{2})$/, '$1****$3')
    }
  },
  methods: {
    // 查询城市下贷款顾问数量
    _getCounselorCountByCity () {
      let vm = this
      this.$http({
        url: '/getCounselorCountByCity.jhtml',
        data: {
          cityNo: vm.$store.state.city.code
        },
        done (data) {
          vm.$store.commit('updateHasConselor', data > 0)
        }
      })
    },
    // 获取城市列表
    _fetchData () {
      let vm = this
      this.$http({
        url: '/getCitys.jhtml',
        done (list) {
          vm.cityList = vm._setDefault([].concat(list))
        }
      })
    },
    _setDefault (list) {
      list.forEach((item) => {
        item.active = item.cityCode === this.$store.state.city.code
      })
      return list
    },
    setNavActive () {
      this.menuArr.map(item => {
        let cls = ''
        if (item.reg && item.reg.test(this.$route.path)) {
          cls = 'active'
        }
        this.$set(item, 'cls', cls)
      })
    },
    setCityActive (index) {
      this.cityList.forEach((item, i) => {
        item.active = i === index
      })
      this.city = this.cityList[index]
    },
    toLogin (e) {
      this.$router.push('/login')
    },
    toLogout (e) {
      this.$dialog('确认退出登录？', (e) => {
        this.$store.commit('clearToken')
        if (this.$route.meta.requireAuth) {
          this.$router.replace('/')
        }
      })
    },
    onClick (index) {
      this.setCityActive(index)
      let city = {}
      city.code = this.city.cityCode
      city.name = this.city.cityName
      if (this.city.hotline) {
        city.remarks = this.city.hotline
      }
      this.$store.commit('changeCity', city)
      this.isShow = false
    }
  }
}
</script>
<style lang="stylus" rel="stylesheet/stylus" scoped>
  navBarHeight = 60px
  activeColor = rgb(43, 158, 252)
  navBarColor = rgb(51, 51, 51)
  .navbar
    position fixed
    width 100%
    min-width 1180px
    height navBarHeight
    margin-bottom 0
    top 0
    transition top 0.4s
    box-shadow 0px 1px 15px 3px rgba(0, 0, 0, 0.16)
    background-color rgba(255, 255, 255, 1)
    border 0
    z-index 1000
    border-radius 0
    &>.container
      position relative
      height navBarHeight
      .navbar-logo
        float left
        .navbar-brand
          font-size 0
          height navBarHeight
          padding-top 12px
          padding-bottom 12px
          margin-left 0
          padding-left 0
          padding-right 10px
          display: block
          img
            vertical-align: middle
  .navbar-phone
    padding-left 10px
    height 100%
    float left
    line-height navBarHeight
    line-height unquote('72px\9') /* ie 9*/
    color #0068b7
    font-size 30px
    font-weight bold
    position relative
    vertical-align middle
    &:after
      content ''
      position absolute
      width 1px
      left 4px
      top 17px
      left 0
      height 26px
      background-color #0068b7
  .navbar-city
    margin-left 15px
    width 86px
    height 100%
    float left
    position relative
    line-height 40px
    .current-city
      letter-spacing 1px
      z-index 2
      position absolute
      bottom 0
      display block
      height 50px
      line-height 18px
      padding 5px 10px
      box-sizing border-box
      color #0068b7
      cursor pointer
      border-top-right-radius 4px
      border-top-left-radius 4px
      border 1px solid transparent
      background-color #fff
      text-indent 15px
      &:after
        content ''
        background url(/static/img/icon_map.png) no-repeat center
        position absolute
        width 10px
        height 14px
        top 7px
        left 10px
      i
        color #999
        font-style normal
        text-indent 0
        font-size 12px
    .city-list
      position absolute
      top 59px
      left 0
      margin 0
      width 170px
      background-color #fff
      border-bottom-left-radius 4px
      border-bottom-right-radius 4px
      border 1px solid #eee
      font-size 12px
      padding 8px 2px
      line-height 30px
      display none
      .city-item
        line-height 20px
        display inline-block
        padding 3px 5px
        height 26px
        margin 0 4px
        border-radius 4px
        cursor pointer
        &:hover
          background-color #e6e6e6
          color: activeColor
        &.active
          background-color activeColor
          color #fff
    &:hover
      .current-city
        border-color #eee
        border-bottom-color #fff
      .city-list
        display block
  .navbar-navs
    height: 100%;
    padding-left 0
    float: left;
    font-size: 0;
    margin: 0;
    .navbar-item
      position relative
      height: 100%;
      display: inline-block;
      font-size: 18px;
      line-height: navBarHeight;
      margin 0 10px
      >a
        display: block;
        color: #333;
        text-decoration: none;
        position: relative;
        padding: 0 8px;
        .angle
          display inline-block
          width 13px
          height 8px
          transform translate(0, -2px)
          background url(/static/img/nav_icon_dow.png)
      &::after
        content: '';
        position: absolute;
        height: 2px;
        background-color: rgba(32, 160, 255, 0);
        width: 100%;
        bottom: 0;
        left: 0;
        transition: 100ms;
      &:hover a, &.active a
        color: activeColor;
        transition: 100ms;
      &:hover, &.active
        &::after
          background-color: #0068b7;
        .angle
          background url(/static/img/nav_icon_up_1.png)
      &:hover
        .navbar-subbar
          display block
        .angle
          background url(/static/img/nav_icon_up.png)
      .navbar-subbar
        position absolute
        display none
        width 100%
        line-height: 30px
        background-color activeColor
        top navBarHeight
        left: 0
        margin 0
        list-style none
        padding 10px 0
        border-bottom-left-radius 4px
        border-bottom-right-radius 4px
        .navbar-subbar-item
          font-size 16px
          >a
            display block
            text-align center
            color #fff
            &:hover
              text-decoration underline
  .navbar-userInfo
    position: absolute;
    right: 0;
    top: 0;
    height: navBarHeight;
    color: #333;
    line-height: navBarHeight;
    .user-info
      height 100%
      font-size 0
    .logout
      color #999
    a, span
      font-size: 14px;
      display inline-block
      padding: 0 5px;
      color: #333;
      text-decoration none
      &:hover,&.active
        color: activeColor;
</style>




// WEBPACK FOOTER //
// navbar.vue?930164c6